import { useEffect, useState } from 'react'

export const useMediaQuery = (query: string) => {
  const getMatches = (query: string) => {
    return window.matchMedia(query).matches
  }

  const [matches, setMatches] = useState(getMatches(query))

  const handleChange = () => {
    setMatches(getMatches(query))
  }

  useEffect(() => {
    const matchMedia = window.matchMedia(query)
    handleChange()
    matchMedia.addEventListener('change', handleChange)

    return () => {
      matchMedia.removeEventListener('change', handleChange)
    }
  }, [query])

  return matches
}
